module.exports = {
    SECRET_KEY: 'mealplannerweb',
    STRIPE_PK_KEY: "pk_test_yGZiq0oVMkjXwJ70VAho4jsb",
    PAY_STRIPE_URL: "https://us-central1-master-meal-planner.cloudfunctions.net/paystripe",
    ROLES: {
        ADMIN: 'admin',
        MANAGER: 'manager',
        AUTHOR: 'author',
        BASIC_MEMBER: 'basic',
        PRO_MEMBER: 'pro',
    },
    COLLECTIONS: {
        USERS: 'users',
        RECIPES: 'recipes',
        DATE_RECIPES: 'date_recipes',
        APP_SETTINGS: 'app_settings',
        EVENTS: 'events',
        MEMBERS: 'members',
        STORIES: 'stories',
        BOOKS: 'books',
        PODCASTS: 'podcasts',
        VIDEOS: 'videos'
    },
    LOG_TYPES: {
        USERS: 'users',
        RECIPES: 'recipes'
    },
    APP_SETTING_KEYS:{
        UNITS: 'units',
        SKILL_LEVEL: 'skill_level',
        RECIPE_LEVEL: 'recipe_level',
        STATE_LIST: 'states',
        QUANTITY: 'quantity'
    },
    LOCAL_STORAGE: {
        LOGIN_USER: 'mealLoginUser',
        IS_AUTHETICATED: 'isAuthenticated',
        LOGIN_SUCCESS: 'LOGIN_SUCCESS',
        TOKEN: 'token'
    },
    FIREBASE_STORAGE: {
        RECIPES: 'recipes/',
        MEMBERS: 'members/',
        COVER_IMAGES: 'coverImages/',
        EVENTS: 'events/',
        STORIES: 'stories/',
        BOOKS: 'books/',
        PODCASTS: 'podcasts/',
        VIDEOS: 'videos/'
    },
    
    MESSAGES: {
        SOMETHING_WRONG: 'Something went wrong!',
        FIREBASE: {
            USER_NOT_FOUND: 'User account not found.',
            WRONG_PASSWORD: 'Login invalid. Try again!',
            CODE_USER_NOT_FOUND: 'auth/user-not-found',
            CODE_WRONG_PASSWORD: 'auth/wrong-password',
            CODE_EMAIL_ALREADY_USE: 'auth/email-already-in-use',
        },
        USER: {
            LOGIN_SUCCESS: 'You are Login Successfully!',
            LOGOUT_SUCCESS: 'You are Logout Successfully!',
            SINGUP_SUCCESS: 'Account created Successfully!',
            SINGUP_FAIL: 'Failed to create account!',
            UPDATE_PASSWORD_FAIL: 'Failed to update password!',
            UPDATE_PASSWORD_SUCCESS: 'Password update Successfully!',
            UPDATE_EMAIL_SUCCESS: 'Email update Successfully, You have to login again!',
            INVALID_PASSWORD: 'Login invalid. Try again!',
            USER_NOT_FOUND: 'Login invalid. Try again!',
            PROFILE_UPDATED: 'User Profile Updated Successfully',
            PASSWORD_UPDATED: 'User Password Updated Successfully',
            PROFILE_UPDATED_FAIL: 'Fail to Update Profile',
            EMAIL_ALREADY_EXISTS: 'Email already exists!',
            LOGOUT_FAIL: 'Fail to logout from firebase!',
            FAIL_GET_USER_PROFILE: 'Fail to Get User Profile',
            EMAIL_DOESNOT_CHANGED: "You didn't changed email"
        },
        RECIPE: {
            ADD_SUCCESS: 'Recipe Added Successfully!',
            UPDATE_SUCCESS: 'Recipe Updated Successfully!',
            REMOVE_SUCCESS: 'Recipe Remove Successfully!',
            GETBY_ID_SUCCESS: 'Recipe Found Successfully!',
            IMAGE_UPLOAD_SUCCESS: 'Image uploaded successfully!',
            VIDEO_UPLOAD_SUCCESS: 'Video uploaded successfully!',
            ADD_FAIL: 'Fail to Add Recipe!',
            REQUIRED_FIELDS_MISSING: 'Required fields are missing!',
            INVALID_FORM: ' Required fields are missing!',
            UPDATE_FAIL: 'Fail to Update Recipe!',
            REMOVE_FAIL: 'Fail to Remove Recipe!',
            GETBY_ID_FAIL: 'Fail to Get Recipe!',
            ALREADY_EXISTS: 'Recipe Already Exists!',
            UPLOAD_FAIL: 'Fail to upload file!',
        },
        EVENT: {
            ADD_SUCCESS: 'Event Added Successfully!',
            UPDATE_SUCCESS: 'Event Updated Successfully!',
            REMOVE_SUCCESS: 'Event Remove Successfully!', 
            DELETE_IMG_SUCCESS: 'Image Remove Successfully!',
            GETBY_ID_SUCCESS: 'Event Found Successfully!',
            IMAGE_UPLOAD_SUCCESS: 'Image uploaded successfully!',
            IMAGE_DELETE_SUCCESS: 'Image Delete successfully!',
            IMAGE_DELETE_FAIL: 'Image Delete Fail!',
            VIDEO_UPLOAD_SUCCESS: 'Video uploaded successfully!',
            ADD_FAIL: 'Fail to Add Event!',
            REQUIRED_FIELDS_MISSING: 'Required fields are missing!',
            INVALID_FORM: ' Required fields are missing!',
            UPDATE_FAIL: 'Fail to Update Event!',
            REMOVE_FAIL: 'Fail to Remove Event!',
            GETBY_ID_FAIL: 'Fail to Get Event!',
            ALREADY_EXISTS: 'Event Already Exists!',
            UPLOAD_FAIL: 'Fail to upload file!',
        },
        BOOK: {
            ADD_SUCCESS: 'Book Added Successfully!',
            UPDATE_SUCCESS: 'Book Updated Successfully!',
            REMOVE_SUCCESS: 'Book Remove Successfully!', 
        },
        STORY: {
            ADD_SUCCESS: 'Story Added Successfully!',
            UPDATE_SUCCESS: 'Story Updated Successfully!',
            REMOVE_SUCCESS: 'Story Remove Successfully!', 
        },
        PODCAST: {
            ADD_SUCCESS: 'Podcast Added Successfully!',
            UPDATE_SUCCESS: 'Podcast Updated Successfully!',
            REMOVE_SUCCESS: 'Podcast Remove Successfully!', 
        },
        VIDEO: {
            ADD_SUCCESS: 'Video Added Successfully!',
            UPDATE_SUCCESS: 'Video Updated Successfully!',
            REMOVE_SUCCESS: 'Video Remove Successfully!', 
        },
        SUBSCRIPTION: {
            SUB_SUCCESS: 'You are subscribed successfully!',
            SUB_FAIL: 'There are some error for payment!',
            CARD_DETAILS_MISSING: 'Please enter card details!'
        }
    },
    LIST: {
        RECIPE_TYPES: [
            {text: 'Breakfast', value: 'breakfast'},
            {text: 'Lunch', value: 'lunch'},
            {text: 'Dinner', value: 'dinner'}
        ],
        SKILL_LEVEL: [
            {text: 'Beginner', value: 'Beginner'},
            {text: 'Intermediate', value: 'Intermediate'},
            {text: 'Advanced', value: 'Advanced'},
        ],
        TIME_LIST: [
            {text: '10 min', value: '10 min'},
            {text: '15 min', value: '15 min'},
            {text: '20 min', value: '20 min'},
            {text: '30 min', value: '30 min'},
            {text: '45 min', value: '45 min'},
            {text: '60 min', value: '60 min'},
            {text: '90 min', value: '90 min'},            
            {text: '120 min', value: '120 min'}
        ],
        UNIT_LIST: [
            {text: 'oz', value: 'oz'},
            {text: 'cups', value: 'cups'},
            {text: 'tsp', value: 'tsp'},
            {text: 'tbsp', value: 'tbsp'}
        ],
        QTY_ITEMS: [
            {text: '1', value: '1'},
            {text: '2', value: '2'},
            {text: '3', value: '3'},
            {text: '4', value: '4'},
            {text: '5', value: '5'},
            {text: '6', value: '6'},
            {text: '7', value: '7'},
            {text: '8', value: '8'},
            {text: '9', value: '9'},
            {text: '10', value: '10'},
            {text: '11', value: '11'},
            {text: '12', value: '12'},
            {text: '13', value: '13'},
            {text: '14', value: '14'},
            {text: '15', value: '15'},
            {text: '16', value: '16'},
            {text: '17', value: '17'},
            {text: '18', value: '18'},
            {text: '19', value: '19'},
            {text: '20', value: '20'}
        ],
        SUBSCRIPTION_PLANS: [
            {text: 'Basic', value: 'basic'},
            {text: 'Weekly - $9.99', value: 'weekly'},
            {text: 'Monthly - $49.99', value: 'monthly'},
            {text: 'Yearly - $249.99', value: 'yearly'},
        ],
        SUBSCRIPTION_PLANS_NEW: [
            {text: 'Monthly - $49.99', value: 'monthly'},
            {text: 'Yearly - $249.99', value: 'yearly'},
        ],
        PUBLISH_STATUS_LIST: [
            {text: 'Publish', value: 'publish'},
            {text: 'Draft', value: 'draft'},
            {text: 'Pending', value: 'pending'},
            {text: 'Trash', value: 'trash'}
        ]
    },
    DEFAULTS: {
        defaultAvatarSrc: 'https://firebasestorage.googleapis.com/v0/b/master-meal-planner.appspot.com/o/members%2Fmp-default-member-placeholder-1806-hd.jpg?alt=media&token=4a6eab94-e20e-49ce-8d74-4ddb06cfc2a7'
    }
}